/**
 * Global Error Handlers Component
 * Wraps app to catch unhandled errors
 */

'use client';

import { useGlobalErrorHandlers } from './useGlobalErrorHandlers';

export function GlobalErrorHandlers() {
  useGlobalErrorHandlers({
    logToConsole: true,
    showToast: true,
  });

  return null;
}
